import React, { useState, useRef, useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import Form, { Item, Label, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';

import { useAuth } from '../../../contexts/auth';
import './LoginForm.scss';

export const LoginForm = () => {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);
  const formData = useRef({ account: '', password: '' });

  const onSubmit = useCallback(
    async(e) => {
      e.preventDefault();
      const { account, password } = formData.current;
      setLoading(true);

      const result = await signIn(account.trim().toLocaleUpperCase('vi-VN'), password);
      if (result.isOk) {
        navigate('/overview', { replace: true });
      } else {
        setLoading(false);
        notify(result.message, 'error', 2000);
      }
    },
    [signIn]
  );

  return (
    <form className='login-form' onSubmit={onSubmit}>
      <Form
        labelLocation='top'
        formData={formData.current}
        disabled={loading}
        showColonAfterLabel
      >
        <Item dataField='account' editorType='dxTextBox' editorOptions={accountEditorOptions}>
          <RequiredRule message='Vui lòng nhập tài khoản' />
          <Label text='Tài khoản' />
        </Item>
        <Item dataField='password' editorType='dxTextBox' editorOptions={passwordEditorOptions}>
          <RequiredRule message='Vui lòng nhập mật khẩu' />
          <Label text='Mật khẩu' />
        </Item>
        <ButtonItem>
          <ButtonOptions width='100%' type='default' useSubmitBehavior>
            <span className='dx-button-text'>{loading ? <LoadIndicator width='24px' height='24px' visible /> : 'Đăng nhập'}</span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
    </form>
  );
};

const accountEditorOptions = {
  stylingMode: 'filled',
  mode: 'text',
  value: '',
  inputAttr: { autoComplete: 'username', autoCapitalize: 'characters', spellCheck: 'false' },
  onInput: (e) => {
    const value = e.event?.target?.value ?? '';
    const uppercaseValue = value.toLocaleUpperCase('vi-VN');
    if (value !== uppercaseValue) {
      e.component.option('value', uppercaseValue);
    }
  },
};
const passwordEditorOptions = {
  stylingMode: 'filled', mode: 'password', value: '',
  inputAttr: { autoComplete: 'current-password' },
};
